import React from "react";
const CategoryDetailCom = (props) => {
  return (
    <div className="flex justify-between flex-col items-center xs:w-36 sm:w-40 lg:w-52 lg:h-64 xl:w-72 xl:h-80">
      <div
        className={`xs:w-[9rem] xs:h-[9rem] sm:w-[10.5rem] lg:w-[12rem] rounded-full sm:h-[10.5rem] lg:h-[12rem] ${
          props.onClick ? "cursor-pointer" : "cursor-default"
        } xl:w-[15rem] xl:h-[15rem] overflow-hidden flex  justify-center items-center`}
        style={{ backgroundColor: props.bgcolor }}
        onClick={props.onClick}
      >
        {!!props.latestNewsthubmail?.trim() &&
          !props.latestNewsthubmail.includes("null") && (
            <img
              src={props.latestNewsthubmail}
              className="w-[95%] h-[95%] rounded-full"
              alt={props.latestNewsTitle}
            />
          )}
      </div>
      <div
        className="flex justify-center items-start h-[25%] xs:pt-2 sm:pt-3 sm:pb-2 lg:pt-3"
        onClick={props.onClick}
      >
        <div className="w-full">
          <p
            className={`uppercase text-secondary font-onestSemiBold xs:leading-4 ${
              props.onClick ? "cursor-pointer" : "cursor-default"
            } xs:!text-[13px] sm:text-sm lg:text-base xl:text-base text-center`}
          >
            {props.latestNewsTitle}
          </p>
          <p className="uppercase text-secondary font-onestRegular xs:leading-4 xs:text-xs sm:text-xs lg:text-xs xl:text-sm text-center">
            {props.position}
          </p>
        </div>
      </div>
    </div>
  );
};
export default CategoryDetailCom;
